import { useEffect } from "react";
import { useNavigate } from "@tanstack/react-router";
import { resolveDeepLink } from "@/lib/deep-links";

type AppPlugin = {
  addListener: (
    event: "appUrlOpen",
    cb: (data: { url: string }) => void,
  ) => Promise<{ remove: () => void }> | { remove: () => void };
  getLaunchUrl?: () => Promise<{ url?: string } | null>;
};

function appPlugin(): AppPlugin | null {
  const cap = (globalThis as {
    Capacitor?: { isNativePlatform?: () => boolean; Plugins?: Record<string, unknown> };
  }).Capacitor;
  if (!cap?.isNativePlatform?.()) return null;
  return (cap.Plugins?.["App"] as AppPlugin | undefined) ?? null;
}

/**
 * Apre la schermata giusta quando si tocca un widget della home
 * (`lumen://home | timer | agenda | progress`), anche ad app chiusa.
 */
export function useWidgetDeepLinks() {
  const navigate = useNavigate();

  useEffect(() => {
    const go = (url: string | undefined | null) => {
      if (!url) return;
      const target = resolveDeepLink(url);
      if (target) void navigate({ to: target as never });
    };

    // Web / anteprima: supporto ai parametri ?widget=timer per provare i link.
    if (typeof window !== "undefined") {
      const param = new URLSearchParams(window.location.search).get("widget");
      if (param) go(`lumen://${param}`);
    }

    const app = appPlugin();
    if (!app) return;
    let remove: (() => void) | undefined;
    void Promise.resolve(app.addListener("appUrlOpen", (data) => go(data.url))).then((handle) => {
      remove = handle.remove;
    });
    void app.getLaunchUrl?.().then((res) => go(res?.url));
    return () => remove?.();
  }, [navigate]);
}
